<template>
    <div class="row">
        <input-select class="col-12 col-md-4" label="Tipo" ref="tipo" required :options="options.tipo" v-model="form.tipo"/>
        <input-date-time class="col-12 col-md-4" label="Data do registro" ref="data" required v-model="form.dataRegistro"/>
        <input-text class="col-12 col-md-4" label="Nº do registro" ref="numeroRegistro" required v-model="form.numeroRegistro"/>

        <input-textarea class="col-12" label="Titulo" :max-length="500" placeholder="Máximo 500 caracteres" ref="titulo" required v-model="form.titulo"/>

        <template v-for="pesquisador in form.pesquisadores">
            <input-select :key="pesquisador.id" class="col-12" label="Pesquisador" ref="pesquisador" required :options="options.pessoas" v-model="pesquisador.id">            
                <template #prepend>
                    <b-button v-if="projetoEditavel" class="mr-2"  variant="flat-danger" @click="removerPesquisador(pesquisador)">
                        <i class="fa-solid fa-trash"></i>
                    </b-button>
                </template>
            </input-select>
        </template>

        <div class="col-12">
            <b-button v-if="projetoEditavel"  variant="info" size="sm" @click="adicionarPesquisador">
                <b-icon icon="plus-circle-fill" class="mr-2" />
                Adicionar pesquisador
            </b-button>
        </div>
        
        <hr class="col-12"/>

        <div class="col-12 my-2">
            Porcentagem dos depositantes
        </div>

        <div class="col-12">
            <b-progress height="25px" :max="100" class="mb-2">
                <template v-for="empresa,i in form.depositantes">
                    <b-progress-bar :id="`empresa_${empresa.id}`" animated  :key="empresa.id" :variant="retornarVariante(i)" :label="empresa.text" :value="empresa.percentual"></b-progress-bar>                    <b-tooltip :target="`empresa_${empresa.id}`" :key="`${empresa.id}_tooltip`">{{empresa.text}}</b-tooltip>                
                </template>
            </b-progress>
        </div>
        <input-text v-for="empresa in form.depositantes" :key="empresa.id" :class="`col-12 col-md-${definirGrid}`" type="number" :min="0" :max="100" :label="empresa.text" v-model="empresa.percentual">
            <template #prepend>
                <b-button v-if="projetoEditavel" class="mr-2" variant="flat-danger" @click="removerDepositante(empresa)">
                    <i class="fa-solid fa-trash"></i>
                </b-button>
            </template>
        </input-text>
        
        <hr class="col-12"/>

        <input-text class="col-12" v-if="projetoEditavel" label="Adicionar empresa depositante" v-model="preform.porcentagem">
            <template #prepend>
                <input-select :options="options.depositantes" v-model="preform.depositante"/>
            </template>
            <template #append>
                <div>
                    <b-button variant="info" v-if="projetoEditavel" class="ml-2" @click="adicionarDepositante">
                        <i class="fa-solid fa-plus mr-2"></i>
                        Adicionar
                    </b-button>
                </div>
            </template>
        </input-text>

    </div>
</template>
<script>
import InputSelect from "@/components/inputs/InputSelect.vue";
import InputText from "@/components/inputs/InputText.vue";
import InputTextarea from "@/components/inputs/InputTextarea.vue";
import InputDateTime from "@/components/inputs/InputDateTime.vue";

import helpers from "@/common/utils/helpers";

import ProjetoService from "@/common/services/projeto/projeto.service";

import {FormMixin} from "@/common/mixins/FormMixin";
import {AlertasMixin} from "@/common/mixins/AlertasMixin";

import cloneDeep from "lodash/cloneDeep";


export default {
    name: "ModalPropriedadeIntelectual",
    mixins: [FormMixin, AlertasMixin],
    props : {
        projetoId: {
            type: String,
            required: true
        },
        projetoEditavel : {
            type : Boolean,
            default : false
        }
    },
    components: {
        InputSelect,
        InputText,
        InputTextarea,
        InputDateTime
        
    },    
    data : () => ({
        form : {
            id: null,
            tipo: null,
            dataRegistro : null,
            numeroRegistro : null,
            titulo: "",
            pesquisadores : [
                { id : null }
            ],
            depositantes : []
        },
        preform : {
            depositante : null,
            porcentagem : null
        },
        options : {
            tipo : helpers.getTiposPropriedadeIntelectual(),
            depositantes : [],
            pessoas : [],
            variants : [
                { id : "primary", text : "primary" },
                { id : "success", text : "success" },
                { id : "danger", text : "danger" },
                { id : "warning", text : "warning" },
                { id : "info", text : "info" },
            ]
        }
    }),
    methods : {
        salvar : function(){
            let form = cloneDeep(this.form);
            let percentual = 0;

            form.depositantes.forEach(empresa => {
                percentual += parseInt(empresa.percentual);
            });

            if(percentual != 100){
                this.alertaAviso("A soma das porcentagens deve ser 100%");
                return;
            }

            form.depositantes = form.depositantes.map(el => {
                let final  = el.el;
                final.percentual = el.percentual;

                return final;
            })

            form.pesquisadores = form.pesquisadores.map(el => {
                return el.id;
            })

            this.$emit('salvar', form);
        },
        editar : function(e){
            let form = cloneDeep(e);

            form.depositantes = form.depositantes.map(el => {                
                let x = cloneDeep(el);
                delete x.percentual;
                return {
                    id : el.projetoCooperadaDepositanteId 
                                || el.projetoDepositanteId
                                || el.projetoExecutoraCriadoraId
                                || el.projetoExecutoraId,
                    percentual : el.percentual,
                    el : x
                }
            })

            form.dataRegistro = helpers.formatarDataBr(form.dataRegistro);
            
            this.form = form;
            this.tratarEmpresas();
        },

        adicionarPesquisador : function(){
            this.form.pesquisadores.push({ id : null });
        },
        removerPesquisador : function(e){
            this.form.pesquisadores.splice(e, 1);
        },

        removerDepositante : function(e){
            this.form.depositantes.splice(e, 1);
        },

        adicionarDepositante : function(){
            if(!this.preform.depositante){
                this.alertaAviso("Selecione uma empresa depositante");
                return;
            }
            if(this.form.depositantes.find(el => el.id == this.preform.depositante)){
                this.alertaAviso("Empresa depositante já adicionada");
                return;
            }

            if(!this.preform.porcentagem){
                this.alertaAviso("Informe a porcentagem");
                return;
            }
            let el = this.options.depositantes.find(el => el.value == this.preform.depositante);
            
            this.form.depositantes.push(
                {
                    id : el.value,
                    text : el.text,
                    percentual : this.preform.porcentagem,
                    el : el.el
                }
            );
            this.$forceUpdate();
        },

        buscarEmpresas : function(){
            
            ProjetoService.listarEmpresas(this.projetoId).then(response => {
                this.options.depositantes = response.data.data.map(el => {
                    return {
                        value : el.projetoCooperadaDepositanteId 
                                || el.projetoDepositanteId
                                || el.projetoExecutoraCriadoraId
                                || el.projetoExecutoraId,
                        text : el.razaoSocial,
                        el : el
                    }
                });

                this.tratarEmpresas();
            });
        },

        buscarPessoas : function(){
            ProjetoService.listarPessoas(this.projetoId).then(res => {
                this.options.pessoas = res.data.data.map(el => {
                    return {
                        value: el.id,
                        text: el.nome
                    }
                });
            });
        },

        tratarEmpresas : function(){
            
            let depositantes = this.options.depositantes.map(el => {
                return {
                    id : el.value,
                    text : el.text,
                    percentual : 0,
                    el : el.el
                }
            });

            depositantes.forEach(el => {
                
                let aux = this.form.depositantes.find(el2 => el2.id == el.id)
                
                if(aux){
                    aux.text = el.text;
                    this.$forceUpdate();
                }
            });
        },

        retornarVariante : function(i){
            let n = i+"";
            let ultima = n.substr(n.length - 1);

            if(ultima > 4){
                ultima -= 5;
            }

            return this.options.variants[ultima].id;
        }

        
    },
    mounted(){
        this.buscarEmpresas();
        this.buscarPessoas();
    },
    computed : {
        definirGrid : function(){
            let tamanhoEmpresas = this.form.depositantes.length;

            if(tamanhoEmpresas == 1){
                return 12;
            }

            if(tamanhoEmpresas % 4 == 0){
                return 3;
            }

            if(tamanhoEmpresas % 3 == 0){
                return 4;
            }

            if(tamanhoEmpresas % 2 == 0){
                return 6;
            }

            return 4;

        },
    }
}
</script>
<style lang="">
    
</style>